// Bridge module to break circular dependency between main.js and editor modules.
// main.js registers the real renderAll; other modules import the proxy.
let _renderAll = null;

export function registerRenderAll(fn) { _renderAll = fn; }

export function renderAll() {
  if (_renderAll) _renderAll();
}
